<template>
    <div class="activity" v-show="view">
        <!-- 非活动商品详情 -->
        <div class="heade">
            <img :src="info.coverImg" alt="" />
            <img
                src="../img/xiajia.png"
                alt=""
                style="position: absolute; top: 0; left: 0; right: 0"
                v-if="info.goodsStatus == '2'"
            />
        </div>
        <div class="main">
            <div class="item1">
                <div class="line1">
                    <span class="color1 fontSize30">¥&nbsp;</span>
                    <span class="color1 fontSize44">{{ info.salePrice }}</span>
                    <!-- <span
            class="color2 fontSize22"
            style="margin-left: 0.4rem; text-decoration: line-through"
            >¥<span class="color2 fontSize30" style="font-family: HelveticaNeue;">{{ info.originPrice }}</span>
            </span> -->
                </div>
                <div class="line2" v-if="info.highlights">
                    <span v-for="(item, i) in tags" :key="i">{{ item }}</span>
                </div>
                <div class="line3">
                    <div class="name">{{ info.title }}</div>
                </div>
                <div class="line4">
                    <div class="info">
                        {{ info.subTitle }}
                    </div>
                </div>
            </div>

            <merchant
                :list="info.marketingList"
                :tab="tabs"
                :years="info.years"
                :skuNo="info.skuNo"
                v-if="info.packType == '2'"
            >
            </merchant>

            <div class="item3" v-if="info.goodsType === '8' || info.goodsType === '9'">
                <div class="cell" id="shangpinfuwu" @click="shangpin()">
                    <span>商品包含以下服务</span>
                    <van-icon name="arrow" color="#999" />
                </div>
            </div>
            <readAgerr
                class="read-agerr"
                ref="readAgeer"
                type="1"
                button="1"
                :isAgent="isAgent"
                :info="info"
                :goodsBargain="goodsBargain"
                v-show="show"
            >
            </readAgerr>
            <div
                class="item4"
                v-show="
                    (info.serviceDetailsList && info.serviceDetailsList.length) ||
                    (info.explainNames && info.explainNames.length)
                "
            >
                <van-tabs
                    v-model="serviceDetailIndex"
                    class="sd-tab"
                    v-if="info.serviceDetailsList && info.serviceDetailsList.length"
                    scrollspy
                    sticky
                >
                    <van-tab
                        v-for="(sd, i) in info.serviceDetailsList"
                        :title="sd.title"
                        :key="i"
                    >
                        <div
                            class="txt ql-editor"
                            v-if="
                                info.serviceDetailsList && info.serviceDetailsList.length
                            "
                            v-html="sd.detail"
                            id="htmlText"
                        ></div>
                    </van-tab>
                </van-tabs>
            </div>
            <div class="footer">
                <!-- <van-action-sheet v-model="show" :overlay="false"> -->
                <action
                    type="1"
                    button="1"   
                    ref="actionRef"
                    :isAgent="isAgent"
                    :info="info"
                    :goodsBargain="goodsBargain"
                    v-show="show"
                ></action>
                <!-- </van-action-sheet> -->
            </div>
        </div>

        <van-popup
            v-model="shangpinfuwu"
            position="bottom"
            round
            :close-on-click-overlay="false"
        >
            <div class="item-list-popup" id="shangpinfuwutankuang">
                <div class="header">
                    <span>商品包含以下服务</span>
                    <img @click="shangpinguanbi" src="../img/ico_close.svg" />
                </div>
                <div class="detail-list">
                    <div class="detail-item" v-for="(item, index) in items" :key="index">
                        <packageItem
                            :item="item"
                            @tipClick="tipClick(item)"
                        ></packageItem>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup
            v-model="tipPopup.show"
            position="center"
            round
            style="overflow-y: initial"
            :close-on-click-overlay="false"
        >
            <div class="item-tip-popup">
                <div class="header">使用说明</div>
                <img
                    class="close"
                    @click="tipPopup.show = false"
                    src="../img/ico_close4.svg"
                />
                <div class="description">
                    {{ tipPopup.item && tipPopup.item.description }}
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import action from './action';
import readAgerr from './read';
import packageItem from './package-item';
import getWXSign from '../../../libs/wxSign';
import merchant from '../../common/merchant/merchant';
export default {
    components: {
        action,
        merchant,
        readAgerr,
        packageItem,
    },
    data() {
        return {
            view: false,
            show: true,
            shangpinfuwu: false,
            type: '',
            info: {
                explainNames: [],
            },
            tags: [],
            isAgent: '',
            goodsBargain: {},
            channelType: '',
            tabs: [],
            serviceDetailIndex: 0,
            tipPopup: {
                show: false,
                item: null,
            },
            items: [],
        };
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 6) {
                return value.slice(0, 6);
            }
            return value;
        },
    },
    created() {
        this.isAgent = JSON.parse(sessionStorage.getItem('user')).isAgent;
        this.detail();
        this.channelType = JSON.parse(sessionStorage.getItem('user')).channelType;
    },
    methods: {
        detail() {
            let {
                skuNo,
                channel,
                shareMemberId,
                saleMerchantId,
                saleStoreId,
                assistantId,
                sellType,
                sellLabel,
                redirect,
            } = this.$route.query;
            let post = {
                shareMemberId,
                channel,
                skuNo,
                saleMerchantId,
                saleStoreId,
                assistantId,
                sellType,
                memberId: JSON.parse(sessionStorage.getItem('user')).memberId,
                redirect,
                sellLabel,
            };
            this.$api.goodsDetail2(post).then((res) => {
                if (res.errno == '0') {
                    res.data.explainNames.forEach((item, index, array) => {
                        if (item.explainType == '3') item.explainTypeName = '服务说明';
                    });

                    this.info = res.data;
                    // this.tabs = this.info.items.filter((item) => item.isMarketing != '1');
                  

                    this.tags = this.info.highlights.split(',');
                    this.view = true;
                    if (this.channelType == 'wechat') this.wxShare();
                    if (this.channelType == 'app') this.appShare();

                    this.setInitialPoint();//埋点

                    this.$nextTick(() => {
                        this.$trackFn.load('shangpinfuwu', 'view_material', {
                            // 活动规则按钮曝光 - 埋点
                            page_type: 'good_detailh5',
                            page_attr: 'normal',
                            card_type: 'content',
                            card_id: shareMemberId,
                            item_id: this.info.skuNo,
                            item_type: 'product_id',
                            sell_type: sellType,
                            sell_label: sellLabel,
                            sell_from:
                                JSON.parse(sessionStorage.getItem('user')).channelType ==
                                'app'
                                    ? 'yljkapp'
                                    : JSON.parse(sessionStorage.getItem('user'))
                                          .channelType == 'assistant'
                                    ? 'ydbapp'
                                    : 'wx_off',
                            material_type: 'btn',
                        });
                    });

                    this.$nextTick(() => {
                        this.$trackFn.load('lijigoumai', 'view_material', {
                            page_type: 'good_detailh5',
                            page_attr: 'normal',
                            card_type: 'bottom_bar',
                            card_id: shareMemberId,
                            item_id: this.info.skuNo,
                            item_type: 'product_id',
                            sell_type: sellType,
                            sell_label: sellLabel,
                            sell_from:
                                JSON.parse(sessionStorage.getItem('user')).channelType ==
                                'app'
                                    ? 'yljkapp'
                                    : JSON.parse(sessionStorage.getItem('user'))
                                          .channelType == 'assistant'
                                    ? 'ydbapp'
                                    : 'wx_off',
                            material_type: 'original_price',
                            material_link: this.info.orderSubmitUrl,
                        });
                    });

                    this.info.explainNames.forEach((item, index) => {
                        this.$nextTick(() => {
                            this.$trackFn.load('tioakuanxieyi', 'view_material', {
                                // 曝光 - 埋点
                                page_type: 'good_detailh5',
                                page_attr: 'normal',
                                card_type:
                                    item.explainTypeName == '投保须知'
                                        ? 'insure'
                                        : item.explainTypeName == '保险条款'
                                        ? 'clause'
                                        : item.explainTypeName == '健康告知书'
                                        ? 'inform'
                                        : 'agreement',
                                card_id: shareMemberId,
                                item_id: this.info.skuNo,
                                item_type: 'product_id',
                                sell_type: sellType,
                                sell_label: sellLabel,
                                sell_from:
                                    JSON.parse(sessionStorage.getItem('user'))
                                        .channelType == 'app'
                                        ? 'yljkapp'
                                        : JSON.parse(sessionStorage.getItem('user'))
                                              .channelType == 'assistant'
                                        ? 'ydbapp'
                                        : 'wx_off',
                                material_type: 'btn',
                            });
                        });
                        let href = encodeURIComponent(window.location.href);
                        this.$nextTick(() => {
                            this.$trackFn.load('tuijianhaoyou', 'view_material', {
                                page_type: 'good_detailh5',
                                page_attr:
                                    this.info.goodsStatus == '1'
                                        ? this.goodsBargain.userBargainStatus == '0'
                                            ? 'no_started'
                                            : this.goodsBargain.userBargainStatus == '3'
                                            ? 'finished'
                                            : 'ongoing'
                                        : 'off_shelf',
                                card_type: 'bottom_bar',
                                card_id: shareMemberId,
                                item_id: this.info.skuNo,
                                item_type: 'product_id',
                                sell_type: sellType,
                                sell_label: sellLabel,
                                sell_from:
                                    JSON.parse(sessionStorage.getItem('user'))
                                        .channelType == 'app'
                                        ? 'yljkapp'
                                        : JSON.parse(sessionStorage.getItem('user'))
                                              .channelType == 'assistant'
                                        ? 'ydbapp'
                                        : 'wx_off',
                                material_type: 'share',
                                material_link: `${window.location.origin}/bill&url${href}`,
                            });
                        });
                        let time1 = new Date().getTime();
                        window.onbeforeunload = (e) => {
                            let time2 = new Date().getTime();
                            let dateDiff = (time2 - time1) / 1000;
                            let page_type = 'good_detailh5';
                            this.$trackFn.view('$pageview', {
                                page_type: page_type,
                                page_attr:
                                    this.info.goodsStatus == '1' ? 'normal' : 'off_shelf',
                                event_duration: dateDiff,
                                card_id: shareMemberId,
                                item_id: this.info.skuNo,
                                item_type: 'product_id',
                                sell_type: sellType,
                                sell_label: sellLabel,
                                sell_from:
                                    JSON.parse(sessionStorage.getItem('user'))
                                        .channelType == 'app'
                                        ? 'yljkapp'
                                        : JSON.parse(sessionStorage.getItem('user'))
                                              .channelType == 'assistant'
                                        ? 'ydbapp'
                                        : 'wx_off',
                            }); // 商品列表页 ——浏览埋点
                            sessionStorage.setItem('pageType', page_type);
                            // return "关闭提示";
                        };
                    });
                }
            });
        },

           //使用sensor1.22.6埋点 
        setInitialPoint(){
            // 商品sku 商品名字 商品售价 商品主类型 商品子类型 店员id 店员名称 门店id 门店名称
            const {memberId} =JSON.parse(sessionStorage.getItem("user"))
            const {pageType} = this.$route.query;
            const from = {
                '1':'1:通过扫药店宝二维码进入',
                '2':'2:通过个人分销首页商品列表进入',
                '3':'3:通过其他人的分享链接跳转',
            }
            const {
                skuNo,
                title,
                salePrice,
                productType,
                productTypeText,
                productSubtype,
                productSubtypeText,
                assistantId,
                assistantName,
                storeId,
                storeName,
            } = this.info;
            this.$newTrackFn.send('FX_user_productdetail_view', {
                member_id:memberId,
                product_sku:skuNo,
                product_name:title,
                product_price:salePrice,
                product_type:`${productType}:${productTypeText}`,
                product_subtype:`${productSubtype}:${productSubtypeText}`,
                assistant_id:assistantId,
                assistant_name:assistantName,
                store_id:storeId,
                store_name:storeName,
                referrer_page_type:from[pageType],
            });
        },


        model(type) {
            console.log(type);
            this.type = type;
        },
        wxShare() {
            getWXSign().then((jssdk) => {
                let {
                    skuNo,
                    shareMemberId,
                    recordId,
                    sellType,
                    sellLabel,
                    channel,
                } = this.$route.query;
                let post = {
                    skuNo,
                    recordId,
                    channel,
                    shareMemberId,
                    sellType,
                    sellLabel,
                };
                this.$api.bargainShare(post).then((res) => {
                    const configData = res.data; 
                    jssdk.updateAppMessageShareData({
                        title: configData.title, // 分享标题
                        desc: configData.subtitle, // 分享描述
                        link: configData.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl:configData.picUrl, // 分享图标
                        success: function () {},
                    });
                 
                });
            });
        },
        appShare() {
            let {
                skuNo,
                shareMemberId,
                recordId,
                sellType,
                sellLabel,
                channel,
            } = this.$route.query;
            let post = {
                skuNo,
                channel,
                recordId,
                shareMemberId,
                sellType,
                sellLabel,
            };
            this.$api.bargainShare(post).then((res) => {
                const configData = res.data;
                let sharObj = {
                    shareLink: configData.shareUrl,
                    shareTitle: configData.title,
                    shareDescr: configData.subtitle,
                    shareImg: configData.picUrl,
                };
                UnionDrugHealthy.showShareIcon(JSON.stringify(sharObj));
            });
        },
        shangpin() {
            this.querySubGoods();

            // this.shangpinfuwu = true;
            let {
                skuNo,
                recordId,
                sellType,
                sellLabel,
                channel,
                shareMemberId,
            } = this.$route.query;
            this.$trackFn.send('click_material', {
                page_type: 'good_detailh5',
                page_attr: 'normal',
                item_id: this.info.skuNo,
                item_type: 'product_id',
                card_type: 'content',
                card_id: shareMemberId,
                sell_type: sellType,
                sell_label: sellLabel,
                sell_from:
                    JSON.parse(sessionStorage.getItem('user')).channelType == 'app'
                        ? 'yljkapp'
                        : JSON.parse(sessionStorage.getItem('user')).channelType ==
                          'assistant'
                        ? 'ydbapp'
                        : 'wx_off',
                material_type: 'btn',
            });
            this.$nextTick(() => {
                this.$trackFn.load('shangpinfuwutankuang', 'view_material', {
                    // 商品详情部分曝光 - 埋点
                    page_type: 'good_detailh5',
                    page_attr: 'normal',
                    card_type: 'content_popup',
                    card_id: shareMemberId,
                    item_id: this.info.skuNo,
                    item_type: 'product_id',
                    sell_type: sellType,
                    sell_label: sellLabel,
                    sell_from:
                        JSON.parse(sessionStorage.getItem('user')).channelType == 'app'
                            ? 'yljkapp'
                            : JSON.parse(sessionStorage.getItem('user')).channelType ==
                              'assistant'
                            ? 'ydbapp'
                            : 'wx_off',
                    material_type: 'popup',
                });
            });
        },

        querySubGoods() {
            let { skuNo, channel } = this.$route.query;

            this.$api
                .getSubGoodsList({
                    skuNo,
                    channel,
                })
                .then((res) => {
                    if (res.errno == '0') {
                        const { items } = res.data;
                        this.items = items;
                        this.tabs = items.filter((item) => item.isMarketing != '1');
                        this.shangpinfuwu = true;
                    }
                });
        },

        shangpinguanbi() {
            this.shangpinfuwu = false;
            let {
                skuNo,
                recordId,
                sellType,
                sellLabel,
                channel,
                shareMemberId,
            } = this.$route.query;
            this.$trackFn.send('click_material', {
                // 商品服务点击 - 埋点
                page_type: 'good_detailh5',
                page_attr: 'normal',
                item_id: this.info.skuNo,
                item_type: 'product_id',
                card_type: 'content_bar',
                card_id: shareMemberId,
                sell_type: sellType,
                sell_label: sellLabel,
                sell_from:
                    JSON.parse(sessionStorage.getItem('user')).channelType == 'app'
                        ? 'yljkapp'
                        : JSON.parse(sessionStorage.getItem('user')).channelType ==
                          'assistant'
                        ? 'ydbapp'
                        : 'wx_off',
                material_type: 'close',
            });
        },
        tipClick(item) {
            this.tipPopup.show = true;
            this.tipPopup.item = item;
        },
    },
};
</script>
<style lang="scss" scoped>
.activity {
    height: 100vh;
    overflow-y: scroll;
    .heade {
        position: relative;
        img {
            max-height: 6.3rem;
        }
    }
    .main {
        padding: 0 0 2rem;
        border-radius: 0px;
        .item1,
        .item2,
        .item3,
        .item4 {
            background: #fff;
            border-radius: 16px;
            padding: 0.4rem 0.3rem 0.2rem;
            margin-bottom: 0.2rem;
        }
        .item1 {
            padding-bottom: 0.4rem;
            .line1,
            .line2,
            .line3 {
                margin-bottom: 0.28rem;
            }
            .line1 {
                position: relative;
            }
            .rule {
                position: absolute;
                right: -4.5%;
                top: 18%;
                height: 40px;
                width: 112px;
                font-size: 0.2rem;
                color: #fff;
                background: #ff8e00;
                border-radius: 24px 0px 0px 24px;
            }
            .line2 {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 0.38rem;
                span {
                    background: rgba(255, 136, 0, 0.1);
                    border-radius: 0.04rem;
                    font-size: 0.24rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ff8800;
                    line-height: 0.24rem;
                    margin-right: 20px;
                    padding: 0.08rem 0.1rem;
                }
            }
            .line3 {
                margin-bottom: 0.22rem;
                .name {
                    font-size: 36px;
                    font-weight: 600;
                    color: #333333;
                }
            }
            .line4 {
                .info {
                    font-size: 0.28rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 0.44rem;
                }
            }
        }
        .item3 {
            padding-top: 0.43rem;
            padding-bottom: 0.43rem;
            .cell {
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                span {
                    font-size: 0.3rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 0.3rem;
                }
            }
        }
        .item4 {
            padding: 0;
            ::v-deep.sd-tab.van-tabs {
                .van-tabs__wrap {
                    height: 1rem;
                }
                .van-tab {
                    max-width: 33%;
                    min-width: 33%;
                    /*flex: none !important;*/

                    .van-tab__text {
                        font-size: 0.32rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #999;
                        line-height: 0.32rem;
                    }
                    &.van-tab--active .van-tab__text {
                        color: #333;
                    }
                }
                .van-tabs__line {
                    width: 1.28rem;
                    height: 0.06rem;
                    background: linear-gradient(124deg, #f26b57 0%, #f83a2c 100%);
                    border-radius: 0.03rem;
                }
            }

            .ql-editor {
                padding-top: 0.24rem !important;
                ::v-deep {
                    img {
                        width: 100%;
                        display: block;
                    }
                }
            }
            ::v-deep {
                #htmlText > div {
                    padding: 0 !important;
                }
            }
        }
    }
    ::v-deep.read-agerr.content {
        border-radius: 0.16rem;
        padding: 0.01rem 0.3rem 0.01rem;
        margin-bottom: 0.2rem;
        background: #fff;
        .read {
            padding-top: 0.24rem;
            a {
                color: #dd2b1e;
            }
        }
    }
    .footer {
        position: fixed;
        bottom: 0;
        padding-bottom: env(safe-area-inset-bottom);
        width: 100%;
        z-index: 9;
        background: #ffffff;
        box-shadow: 0rem -0.08rem 0.12rem 0rem rgba(0, 0, 0, 0.06);
        border-radius: 0.2rem 0.2rem 0rem 0rem;
        .content {
            padding: 0.12rem 0.3rem;
        }
        // ::v-deep.shangpinfuwu {
        //   z-index: 2005 !important;
        // }
        // ::v-deep.van-popup--bottom.van-popup--round {
        //   border-radius: 0.16rem 0.16rem 0px 0px;
        // }
    }
    ::v-deep.van-popup--center {
        background-color: unset;
    }
    // ::v-deep.van-overlay {
    //   z-index: 2001 !important;
    // }
    .shangpinfuwu {
        ::v-deep.van-action-sheet__header {
            text-align: left;
            font-size: 0.36rem;
            font-weight: 600;
            color: #333333;
            padding-left: 0.4rem;
            padding-top: 0.4rem;
        }
        ::v-deep.van-card {
            background: #fff;
            padding: 0.4rem 0;
            border-top: 1px solid #eee;
        }
        ::v-deep.van-card__title {
            font-size: 0.28rem;
            font-weight: 500;
            color: #333333;
            width: 4rem;
        }
        ::v-deep.van-card__price {
            color: #dd2b1e;
        }
        ::v-deep.van-card__num {
            position: absolute;
            right: 0;
            top: 1%;
            line-height: 1;
            color: #333333;
        }
    }
}
img {
    width: 100%;
    vertical-align: bottom;
}
.flex {
    display: flex;
    align-items: center;
    justify-content: center;
}
.mainbg1 {
    background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
}
.mainbg2 {
    background: linear-gradient(135deg, #dddddd 0%, #aaaaaa 100%);
}
.color1 {
    color: #ff5d5d;
}
.color2 {
    color: #999999;
}
.fontSize20 {
    font-size: 20px;
}
.fontSize22 {
    font-size: 22px;
}
.fontSize30 {
    font-size: 30px;
}
.fontSize44 {
    font-size: 44px;
}

::v-deep#merchant {
    .item-2,
    .item-3 {
        display: none;
    }
}
.item-list-popup {
    background: #ffffff;
    padding: 0 0.3rem;
    display: flex;
    flex-direction: column;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0.4rem 0;

        span {
            font-size: 0.36rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 0.36rem;
        }

        img {
            width: 0.44rem;
            height: 0.44rem;
        }
    }
    .detail-list {
        max-height: 6rem;
        overflow-y: auto;
        &::-webkit-scrollbar {
            display: none;
        }
    }
}
.item-tip-popup {
    background: #ffffff;
    border-radius: 0.24rem;
    padding: 0.4rem;
    padding-bottom: 0.32rem;
    display: flex;
    flex-direction: column;
    width: 90vw;
    max-height: 8rem;
    min-height: 6rem;
    box-sizing: border-box;
    position: relative;

    .header {
        font-size: 0.36rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3a3a3a;
        line-height: 0.36rem;
        text-align: center;
    }
    .close {
        position: absolute;
        width: 0.6rem;
        height: 0.6rem;
        left: 50%;
        bottom: -1.2rem;
        transform: translateX(-50%);
    }
    .description {
        flex: 1;
        margin-top: 0.32rem;
        overflow-y: auto;
    }
}
</style>
